const initialState = () => ({
  sidebarId: null,
  sidebarVisible: false,
  forceSidebarVisibility: false,
  resizeSize: {
    width: 0,
    height: 0,
  },
})

export const state = initialState()

export const mutations = {
  UPDATE_SIDEBAR_VISIBLILITY(state, payload) {
    state.sidebarVisible = payload
  },
  UPDATE_SIDEBAR_ID(state, payload) {
    state.sidebarId = payload
  },
  UPDATE_FORCE_SIDEBAR_VISIBILITY(state, payload) {
    state.forceSidebarVisibility = payload
  },
  UPDATE_RESIZED_SIZE(state, { width, height }) {
    state.resizeSize.width = width
    state.resizeSize.height = height
  },
  RESET_RESIZED_SIZE(state) {
    state.resizeSize.width = 0
    state.resizeSize.height = 0
  },
  RESET(state) {
    const newState = initialState()
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key]
    })
  },
}

export const getters = {
  isHomeVisible: (state, getters, rootState) =>
    state.sidebarId === rootState.Messages.homeSid && state.sidebarVisible,
}

export const actions = {
  /**
   * Reset state
   * @param {*} { commit }
   */
  reset({ commit }) {
    commit('RESET')
  },
  toggleSidebar({ commit, state }, sid = null) {
    commit('UPDATE_SIDEBAR_ID', state.sidebarId !== sid ? sid : null)
    if (state.sidebarVisible) {
      commit('UPDATE_SIDEBAR_VISIBLILITY', false)
    } else {
      commit('UPDATE_FORCE_SIDEBAR_VISIBILITY', true)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
